import api from '.'
import { normalizeUser, type User } from '../../data/users'

export async function getToken(credentials: {
  email: string
  password: string
}): Promise<{ token: string; user: User }> {
  const res = await api.post('/token', {
    ...credentials,
    device_name: navigator.userAgent,
  })
  const { token, user } = res.data.data
  localStorage.setItem('td-credential', token)
  return { token, user: normalizeUser(user) }
}
